import { ModalWithTransition } from '@studiometa/ui';
import { withBreakpointObserver } from '@studiometa/js-toolkit';
import ImageZoom from './ImageZoom.js';

/**
 * Modal component
 * @returns {void}
 */
export default class Modal extends withBreakpointObserver(ModalWithTransition) {
  static config = {
    name: 'Modal',
    components: {
      ImageZoom,
    },
  };
}
